module.exports = __webpack_public_path__ + "static/media/india-map.e914a240.jpg";